import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";
import InnerContainerImageGradient from "@components/InnerContainerImageGradient";
import BuyMainHeader from "@components/BuyMainHeader";
import loadable from "@loadable/component";
const BuyPageCardsHeader = loadable(() =>
  import(/* webpackChunkName: "BuyPageCardsHeader" */ "./BuyPageCardsHeader")
);
const Dropdown = loadable(() =>
  import(/* webpackChunkName: "Dropdown" */ "./Dropdown")
);
const CategoriesContainerLargeScreens = loadable(() =>
  import(
    /* webpackChunkName: "CategoriesContainerLargeScreens" */ "./CategoriesContainerLargeScreens"
  )
);
const QuickBuyMobileButton = loadable(
  () =>
    import(
      /* webpackChunkName: "QuickBuyMobileButton" */ "../components/QuickBuyMobileButton"
    ),
  { ssr: false }
);
const BuyTabletButtons = loadable(() =>
  import(/* webpackChunkName: "BuyTabletButtons" */ "./BuyTabletButtons")
);
import Resizer from "@hocs/Resizer";
import CardRow from "@components/CardRow";
import CategoryMessageContainer from "@components/CategoryMessageContainer";
import { registeringNewEvent, fireEvent } from "@modules/Emission/action";
import { getCurrentCategory } from "@modules/Categories/selector";
import BuyPageMessage from "@components/BuyPageMessage";
import { useDispatch, useSelector } from "react-redux";

const CATEGORY_PAGE_VIEW = (tag = false) =>
  "CATEGORY_PAGE_VIEW" + (!tag ? "" : `:${tag}`);

const MainContent = styled.div`
  display: grid;
  grid-template-columns: 250px 1fr;
  margin-top: 40px;
  grid-gap: 30px;
  margin-bottom: 110px;
  @media (max-width: 950px) {
    grid-gap: 0px;
  }
  @media (max-width: 950px) {
    grid-gap: 0px;
  }
  @media (max-width: 767px) {
    display: block;
  }
`;

const CardsHeaderDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  @media (max-width: 500px) {
    grid-template-columns: 1.4fr 1fr;
    grid-gap: 15px;
  }
  @media (max-width: 440px) {
    grid-template-columns: 1.6fr 1fr;
  }
  @media (max-width: 375px) {
    grid-template-columns: 1.3fr 1fr;
  }
  @media (max-width: 340px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const DropdownContainerDiv = styled.div`
  width: 227px;
  justify-self: flex-end;
  @media (max-width: 500px) {
    width: auto;
    justify-self: flex-start;
  }
`;

const CategoryBuyMainPage = () => {
  const dispatch = useDispatch();
  const currentSearch = useSelector(state => state.userActions.buySearchText);
  const selectedCategory = useSelector(
    state => state.userActions.selectedCategory
  );
  const currentCategory = useSelector(state =>
    getCurrentCategory({
      categories: state.categories.allCategories,
      categoryName: state.userActions.selectedCategory
    })
  );

  const [selectedCategoryName, changeSelectedCategory] =
    useState(selectedCategory);

  useEffect(() => {
    if (selectedCategoryName !== selectedCategory) {
      handleEventFire();
      handleEventRegistration();
      changeSelectedCategory(selectedCategory);
    }
  }, [selectedCategory, currentSearch]);

  const handleEventFire = () => {
    if (currentCategory) {
      dispatch(
        fireEvent(CATEGORY_PAGE_VIEW(currentCategory), {
          cat_id: currentCategory
        })
      );
    }
  };

  const handleEventRegistration = () => {
    if (currentCategory) {
      dispatch(
        registeringNewEvent(CATEGORY_PAGE_VIEW(currentCategory.categoryId))
      );
    }
  };
  return (
    <div
      className={`mar-t-128-108 discount-buy-main-page-container orange-caret`}
    >
      <Helmet
        title={`Buy Discount ${currentCategory.categoryName} Gift Cards | CardCash`}
      />
      <Resizer
        components={[
          {
            component: () => <QuickBuyMobileButton setDisplay={"768px"} />,
            break: 1,
            maxBreak: 768
          }
        ]}
      />
      <div>
        <InnerContainerImageGradient />
        <BuyMainHeader
          setClassName={"buy-header-category"}
          headerImg={currentCategory.images.bannerName}
          name={currentCategory.categoryName}
          categorySaleImage={currentCategory.images.saleBanner}
          categoryId={currentCategory.categoryId}
        />
        <MainContent className="main-container-page-width">
          <Resizer
            components={[
              {
                component: () => (
                  <CategoriesContainerLargeScreens
                    guaranteeText={"45-day guarantee"}
                    categoryName={currentCategory.categoryName}
                  />
                ),
                break: 767,
                maxBreak: Number.MAX_SAFE_INTEGER
              }
            ]}
            defaultComponent={() => (
              <CategoriesContainerLargeScreens
                guaranteeText={"45-day guarantee"}
                categoryName={currentCategory.categoryName}
              />
            )}
          />

          <div>
            {currentCategory.message && (
              <CategoryMessageContainer message={currentCategory.message} />
            )}
            <Resizer
              components={[
                {
                  component: () => (
                    <BuyTabletButtons guaranteeText={"45-day guarantee"} />
                  ),
                  break: 1,
                  maxBreak: 768
                }
              ]}
              defaultComponent={() => (
                <BuyTabletButtons guaranteeText={"45-day guarantee"} />
              )}
            />

            <CardsHeaderDiv>
              <BuyPageCardsHeader
                categoryName={currentCategory.categoryName}
                page={"buyCategories"}
              />

              <DropdownContainerDiv>
                <Dropdown />
              </DropdownContainerDiv>
            </CardsHeaderDiv>
            <BuyPageMessage />
            <CardRow />
          </div>
        </MainContent>
      </div>
    </div>
  );
};
export default CategoryBuyMainPage;
